import type { TranslationInterface } from '.';

export const HungarianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Írjon üzenetet...',
  your_issue_has_been_resolved: 'A problémája megoldódott!',
  new_conversation: 'Új beszélgetés',
  welcome_screen_title: 'Üdvözöljük az ügyfélszolgálati chatünkön',
  welcome_screen_description:
    'Azért vagyunk itt, hogy segítsünk! Kezdjen beszélgetést, és mihamarabb válaszolunk.',
  your_name_placeholder: 'Az Ön neve',
  your_email_placeholder: 'Az Ön e-mail címe',
  start_chat_button: 'Beszélgetés az ügyfélszolgálattal',
  start_chat_button_loading: 'Csatlakozás...',
  i_need_more_help: 'További segítségre van szükségem',
  this_was_helpful: 'Ez hasznos volt',
  optional: 'Opcionális',
  no_conversations_yet: 'Még nincsenek beszélgetések',
  back_to_conversations: 'Vissza a beszélgetésekhez',
  closed_conversations: 'Lezárt beszélgetések',
  csat_title: 'Milyen volt a beszélgetése?',
  csat_submitted_title: 'A beszélgetést így értékelte',
  csat_feedback_placeholder: 'Mondjon többet... (opcionális)',
  follow_up_placeholder: 'További kérdés…',
  companion_layout_label: 'Elrendezés',
  companion_layout_floating: 'Lebegő',
  companion_layout_sidebar: 'Oldalsáv',
  companion_layout_fullscreen: 'Teljes képernyő',
  companion_close: 'Bezárás',
  companion_history: 'Beszélgetési előzmények',
  companion_expand_chat: 'Csevegés kibontása',
  companion_sidebar_dock_label: 'Dokkolás',
  companion_sidebar_side_label: 'Oldal',
  companion_sidebar_left: 'Bal',
  companion_sidebar_right: 'Jobb',
  companion_resize_chat: 'Csevegés átméretezése',
  scroll_to_bottom: 'Görgetés az aljára',
  thinking: 'Gondolkodás…',
  running: 'Folyamatban…',
  steps: 'lépés',
  step_arguments: 'Argumentumok',
  step_result: 'Eredmény',
  attach_files:
    'Képek, videók, PDF-ek vagy táblázatok csatolása (legfeljebb 25 MB)',
  mark_page_active:
    'Kattintson valamire az oldalon a megjelöléséhez — Esc a megszakításhoz',
  mark_page: 'Jelöljön meg valamit az oldalon, hogy kérdezhessen róla',
  stop_response: 'Válasz leállítása',
  copy_reply: 'Válasz másolása',
  mentions_empty: 'Nincs találat',
  copied: 'Másolva',
  send_message: 'Üzenet küldése',
  upload_failed: 'A feltöltés sikertelen: {error}',
  remove_attachment: 'Melléklet eltávolítása',
  json_no_items: 'Nincsenek elemek',
  json_no_data: 'Nincs adat',
  json_no_chart_data: 'Nincs megjeleníthető diagramadat',
  json_unsupported: 'Nem támogatott: {type}',
  json_see_less: 'Kevesebb megjelenítése',
  json_phone_agent: 'Telefonos ügynök',
  json_phone_agent_test: 'Tesztelés weben',
  page_context_remove: 'Oldalkontextus eltávolítása',
  json_see_more: 'További {count} megjelenítése',
  queued_label: '{count} Várólistán',
  remove_queued_message: 'Üzenet eltávolítása a várólistáról',
  send_queued_now: 'Várólistán lévő üzenetek küldése most',
  turn_failed_message: 'Hiba történt, és a válasz nem érkezett meg.',
  turn_failed_retry: 'Próbálja újra',
  page_mark_hint: 'Kattintson valamire a megjelöléséhez',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Keret',
  page_mark_shape_circle: 'Kör',
  page_mark_shape_arrow: 'Nyíl',
  page_mark_shape_bracket: 'Zárójel',
  page_mark_shape_underline: 'Aláhúzás',
  page_mark_shape_highlight: 'Kiemelés',
  page_mark_shape_strike_through: 'Áthúzás',
  page_mark_shape_crossed_off: 'Keresztezett áthúzás',
  page_mark_shape_aria: 'Jelölés alakja: {shape}',
  page_mark_note_placeholder: 'Megjegyzés hozzáadása… (Enter a csatoláshoz)',
  page_mark_attach: 'Jelölés csatolása',
  page_mark_remove: '{label} eltávolítása',
  page_mark_region: 'Megjelölt terület',
  page_mark_default_message: 'Mi ez?',
  file_rejected: 'A fájltípus nem támogatott, vagy a fájl túl nagy.',
  dictate: 'Diktálás',
  stop_dictation: 'Diktálás leállítása',
  dictation_mic_blocked: 'A diktáláshoz engedélyezze a mikrofon használatát',
  dictation_unavailable: 'A diktálás jelenleg nem érhető el',
  questions_back: 'Vissza',
  questions_next: 'Tovább',
  questions_send: 'Küldés',
  questions_type_answer: 'Inkább leírom',
  questions_answer_placeholder: 'Írja le a válaszát…',
  close_conversation_title: 'Beszélgetés lezárása',
  close_conversation_description: 'Biztosan lezárja ezt a beszélgetést?',
  close_conversation_cancel: 'Nem',
  close_conversation_confirm: 'Igen',
  dialog_close: 'Bezárás',
  zoom_in: 'Nagyítás',
  zoom_out: 'Kicsinyítés',
  reset_zoom: 'Nagyítás visszaállítása',
  support_chat_aria_label: 'Ügyfélszolgálati chat',
};
